<p>
  Admin Dashboard
</p>
<nav>
  <a routerLink="admin/studies/create" routerLinkActive="active">Go To Study Create</a>
  <br />

</nav>

<router-outlet></router-outlet>